import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
        // err is the actual Error object
        console.error('🐛 [vue:errorHandler]', info, err, instance)
        // optionally re-throw if you want to see the red overlay:
        // throw err
    }

    // Nuxt also emits a nuxt hook you can use:
    nuxtApp.hook('vue:error', (err, instance, info) => {
        console.error('🐛 [nuxt vue:error hook]', info, err, instance)
    })
})